var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.057 34.036q-1.005.977-2.49.977t-2.491-.977L1.05 20.397Q.045 19.42.045 17.975q0-1.444 1.005-2.422L15.076 1.915q1.005-.978 2.49-.977 1.485 0 2.491.977l14.026 13.638q1.005.979 1.005 2.422t-1.005 2.422zm-2.49-2.422 14.026-13.639L17.567 4.337 3.54 17.975zm-1.748-11.94h3.495V9.479H15.82zm1.748 5.1q.742 0 1.246-.49a1.62 1.62 0 0 0 .501-1.21q0-.723-.501-1.212-.504-.488-1.246-.488-.743 0-1.245.488-.503.489-.503 1.212 0 .722.503 1.21.502.49 1.245.49"
})));
export default SvgAtc;